import Detail from './Detail';
import Header from './Header';

export {
  Detail,
  Header,
}



// WEBPACK FOOTER //
// ./src/components/admin/Timecards/Dialog/index.js